import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'moment/locale/cs';

import TimeAgo from 'javascript-time-ago';
import cs from 'javascript-time-ago/locale/cs';
TimeAgo.addDefaultLocale(cs);


if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
